module.exports = __webpack_public_path__ + "img/bg-text.dd79eb9f.svg";